
import { useEffect, useState } from 'react';

const PhilosophySection = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.3 }
    );

    const element = document.getElementById('philosophy-section');
    if (element) {
      observer.observe(element);
    }

    return () => {
      if (element) {
        observer.unobserve(element);
      }
    };
  }, []);

  const philosophyPoints = [
    {
      title: '内调为本',
      content: '从根源调理身体内在平衡，让美丽由内而外自然绽放',
      image: 'https://static.readdy.ai/image/2e1ac11483faca2c19cd44d7d582b015/44fe1d5978a4f79e09872b281df25e90.png'
    },
    {
      title: '外养为辅',
      content: '精心呵护肌肤表层，为内在调理提供完美的外在呈现',
      image: 'https://static.readdy.ai/image/2e1ac11483faca2c19cd44d7d582b015/f6092bd7840afbb793823f390ee83cae.jpeg'
    },
    {
      title: '天人合一',
      content: '顺应自然规律，与四季变化和谐共生，达到身心灵的完美统一',
      image: 'https://static.readdy.ai/image/2e1ac11483faca2c19cd44d7d582b015/099e6cad7c2c2ac48dbfc5763033b9b8.jpeg'
    }
  ];

  return (
    <section 
      id="philosophy-section" 
      className="py-40 relative overflow-hidden"
      style={{ backgroundColor: '#FFFFFF' }}
    >
      <div className="max-w-6xl mx-auto px-8">
        <div className={`text-center mb-20 transform transition-all duration-1000 ${isVisible ? 'translate-y-0 opacity-100' : 'translate-y-8 opacity-0'}`}>
          <h2 
            className="text-2xl lg:text-3xl font-light mb-8"
            style={{ fontFamily: 'PingFang SC, -apple-system, BlinkMacSystemFont, sans-serif', fontWeight: 100, color: '#333333' }}
          >
            品牌理念
          </h2>
          <div className="w-32 h-px mx-auto mb-12" style={{ background: 'linear-gradient(to right, transparent, #ED5736, transparent)' }}></div>
          
          <p 
            className="text-sm lg:text-lg max-w-3xl mx-auto leading-relaxed font-light"
            style={{ fontFamily: 'PingFang SC, -apple-system, BlinkMacSystemFont, sans-serif', fontWeight: 100, color: '#666666' }}
          >
            宫廷养森秉承"养于内，美于外"的核心理念，相信真正的美丽源于内在的和谐与平衡。我们致力于为现代女性提供全方位的内调外养解决方案。
          </p>
        </div>

        <div className="space-y-20">
          {philosophyPoints.map((point, index) => (
            <div
              key={index}
              className={`grid grid-cols-1 lg:grid-cols-2 gap-16 items-center ${
                index % 2 === 1 ? 'lg:grid-flow-col-dense' : ''
              }`}
            >
              {/* Content */}
              <div 
                className={`transform transition-all duration-1000 ${
                  isVisible ? 'translate-x-0 opacity-100' : `${index % 2 === 0 ? '-translate-x-8' : 'translate-x-8'} opacity-0`
                } ${index % 2 === 1 ? 'lg:col-start-2' : ''}`}
                style={{ transitionDelay: `${index * 300}ms` }}
              >
                <h3 
                  className="text-xl lg:text-2xl font-light mb-6"
                  style={{ fontFamily: 'PingFang SC, -apple-system, BlinkMacSystemFont, sans-serif', fontWeight: 100, color: '#333333' }}
                >
                  {point.title}
                </h3>
                
                <div className="w-16 h-px mb-8" style={{ backgroundColor: '#ED5736' }}></div>
                
                <p 
                  className="text-sm lg:text-lg leading-relaxed font-light"
                  style={{ fontFamily: 'PingFang SC, -apple-system, BlinkMacSystemFont, sans-serif', fontWeight: 100, color: '#666666' }}
                >
                  {point.content}
                </p>
              </div>

              {/* Image */}
              <div 
                className={`transform transition-all duration-1000 ${
                  isVisible ? 'translate-x-0 opacity-100' : `${index % 2 === 0 ? 'translate-x-8' : '-translate-x-8'} opacity-0`
                } ${index % 2 === 1 ? 'lg:col-start-1' : ''}`}
                style={{ transitionDelay: `${index * 300 + 200}ms` }}
              >
                <div className="relative">
                  <img
                    src={point.image}
                    alt={point.title}
                    className="w-full h-80 object-cover rounded-lg shadow-lg"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent rounded-lg"></div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PhilosophySection;
